<form [formGroup]="userEntryForm">
    <table>
        <tr>
            <td>
                <mat-form-field style="width:160px;" appearance="fill">
                    <mat-label>{{locationID ? 'Bin / Item' : 'SCAN BIN'}}</mat-label>
                    <input matInput #inventoryID scanInput="*" formControlName="userInput"
                        (scanned)="onUserInputEntered($event)" autofocus />
                    <button mat-icon-button matSuffix type="button" (click)="resetItemEntryForm()">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-form-field>
            </td>
            <td style="vertical-align: top; padding-top:8px;" *ngIf="overstockAuditMode">
                Overstock<br />{{overstockCheckLocationID}}</td>
            <td style="vertical-align: top; padding-top:8px;" *ngIf="locationID">
                Location<br />{{locationID}}</td>
        </tr>
    </table>
</form>

<mat-tab-group (selectedTabChange)="onSelectedTabChanged($event)">
    <mat-tab label="Contents">

        <mat-accordion #binContentAccordion>
            <mat-expansion-panel hideToggle *ngFor="let itemset of locationContents" [expanded]="itemset.expanded"
                (opened)="resetItemEntryForm()" (closed)="resetItemEntryForm()">
                <mat-expansion-panel-header>
                    <mat-panel-title style="white-space:nowrap;">
                        <mat-icon
                            *ngIf="itemset.auditPartial && (!itemset.auditComplete || !itemset.inventoryItem?.isLotSerItem)">done</mat-icon>
                        <mat-icon
                            *ngIf="itemset.auditComplete && itemset.inventoryItem?.isLotSerItem">done_all</mat-icon>
                        <item-thumbnail [item]="itemset.inventoryItem"></item-thumbnail>
                        {{itemset.inventoryID}}
                    </mat-panel-title>
                    <mat-panel-description *ngIf="itemset.inventoryItem">
                        {{itemset.inventoryItem.Description | titleCase}}
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <table mat-table [dataSource]="itemset.pieces">
                    <ng-container matColumnDef="Audited">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let piece"><mat-icon *ngIf="piece.audited">done</mat-icon></td>
                    </ng-container>

                    <ng-container matColumnDef="LotSerialNbr">
                        <th mat-header-cell *matHeaderCellDef>Lot/Ser #</th>
                        <td mat-cell *matCellDef="let piece">{{piece.lotSerialNbr}}</td>
                    </ng-container>

                    <ng-container matColumnDef="Quantity">
                        <th mat-header-cell *matHeaderCellDef style="text-align: right;">Quantity</th>
                        <td mat-cell *matCellDef="let piece" class="numeric" [innerHtml]="piece.QtyAvailable">
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef style="text-align:right;">
                            <span *ngIf="isDevMode">
                                <buton mat-button [matMenuTriggerFor]="menuInventoryItem"
                                    *ngIf="itemset.altLocationPieces === undefined">
                                    <mat-icon>more_vert</mat-icon>
                                </buton>
                                <mat-menu #menuInventoryItem="matMenu">
                                    <button mat-menu-item (click)="searchForMorePiecesOfItem(itemset)">
                                        <mat-icon>search</mat-icon>Search more pieces
                                    </button>
                                </mat-menu>
                            </span>
                        </th>
                        <td mat-cell *matCellDef="let piece; let pieceIndex = index" class="numeric">
                            <buton mat-button [matMenuTriggerFor]="menu">
                                <mat-icon>more_vert</mat-icon>
                            </buton>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="queueStockTag(piece)"
                                    *ngIf="itemset.inventoryItem?.isLotSerItem">
                                    <mat-icon>sell</mat-icon>Stock Tag
                                </button>
                                <button mat-menu-item (click)="inventoryAdjustmentMenu(itemset, pieceIndex)">
                                    <mat-icon>expand</mat-icon>Adjust Qty
                                </button>
                                <button mat-menu-item *ngIf="!piece.audited && itemset.inventoryItem?.isLotSerItem"
                                    (click)="piece.audited = true">
                                    <mat-icon>check</mat-icon>Mark Found
                                </button>
                                <button mat-menu-item *ngIf="piece.audited && itemset.inventoryItem?.isLotSerItem"
                                    (click)="piece.audited = false">
                                    <mat-icon>restart_alt</mat-icon>Clear Found
                                </button>
                            </mat-menu>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="piecesTableCols(itemset.inventoryItem)"></tr>
                    <tr mat-row *matRowDef="let row; columns: piecesTableCols(itemset.inventoryItem);"></tr>
                </table>

                <table mat-table *ngIf="itemset.altLocationPieces && itemset.altLocationPieces.length > 0"
                    [dataSource]="itemset.altLocationPieces">
                    <ng-container matColumnDef="LocationID">
                        <th mat-header-cell *matHeaderCellDef>Location</th>
                        <td mat-cell *matCellDef="let piece">{{piece.LocationID}}</td>
                    </ng-container>

                    <ng-container matColumnDef="LotSerialNbr">
                        <th mat-header-cell *matHeaderCellDef>Lot/Ser #</th>
                        <td mat-cell *matCellDef="let piece">{{piece.LotSerialNbr}}</td>
                    </ng-container>

                    <ng-container matColumnDef="Quantity">
                        <th mat-header-cell *matHeaderCellDef style="text-align: right;">Quantity</th>
                        <td mat-cell *matCellDef="let piece" class="numeric"
                            [innerHtml]="piece.QtyAvailable | quantityFraction">
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="altLocationPiecesTableCols"></tr>
                    <tr mat-row *matRowDef="let row; columns: altLocationPiecesTableCols;"></tr>
                </table>
            </mat-expansion-panel>
        </mat-accordion>

    </mat-tab>

    <mat-tab label="Overstock ({{overstockItemsPending}})" *ngIf="overstockTabVisible">
        <!-- <table mat-table #overstockChecksTable [dataSource]="overstockChecks">
            <ng-container matColumnDef="Thumbnail">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let value"><item-thumbnail [item]="value.item"></item-thumbnail></td>
            </ng-container>

            <ng-container matColumnDef="InventoryID">
                <th mat-header-cell *matHeaderCellDef>Item</th>
                <td mat-cell *matCellDef="let value">{{value.item.InventoryID}}</td>
            </ng-container>

            <ng-container matColumnDef="Location">
                <th mat-header-cell *matHeaderCellDef>Bin</th>
                <td mat-cell *matCellDef="let value">{{value.inventory.LocationID}}</td>
            </ng-container>

            <ng-container matColumnDef="Quantity">
                <th mat-header-cell *matHeaderCellDef style="text-align: right;">Qty</th>
                <td mat-cell *matCellDef="let value" class="numeric" [innerHtml]="value.Qty | quantityFraction"></td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="overstockCheckTableCols"></tr>
            <tr mat-row *matRowDef="let row; columns: overstockCheckTableCols;"></tr>
        </table> -->

        <mat-accordion #overstockAccordion="matAccordion">
            <mat-expansion-panel hideToggle *ngFor="let locationID of overstockCheckLocations"
                [expanded]="overstockExpansionPanels[locationID]"
                (opened)="openOverstockLocationExpansionPanel(locationID)"
                (closed)="closeOverstockLocationExpansionPanel(locationID)">
                <mat-expansion-panel-header>
                    <mat-panel-title style="white-space:nowrap;">
                        <mat-icon *ngIf="overstockLocationAuditDone(locationID)">done</mat-icon>
                        {{locationID}}
                    </mat-panel-title>
                    <!-- <mat-panel-description>                        
                    </mat-panel-description> -->
                </mat-expansion-panel-header>
                <table mat-table #overstockChecksTable [dataSource]="overstockChecks[locationID]">
                    <ng-container matColumnDef="Audited">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let piece"><mat-icon *ngIf="piece.audited">done</mat-icon></td>
                    </ng-container>

                    <ng-container matColumnDef="Thumbnail">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let value"><item-thumbnail [item]="value.item"></item-thumbnail></td>
                    </ng-container>

                    <ng-container matColumnDef="InventoryID">
                        <th mat-header-cell *matHeaderCellDef>Item</th>
                        <td mat-cell *matCellDef="let value" style="white-space:no-wrap;">{{value.item.InventoryID}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Quantity">
                        <th mat-header-cell *matHeaderCellDef style="text-align: right;">Qty</th>
                        <td mat-cell *matCellDef="let value" class="numeric" [innerHtml]="value.Qty | quantityFraction">
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef style="text-align:right;"></th>
                        <td mat-cell *matCellDef="let value" (click)="inventoryNonLotAdjustment(value.item)"
                            style="padding:0;">
                            <button mat-menu-item style="width:32px; padding:0;">
                                <mat-icon>expand</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <!-- <tr mat-header-row *matHeaderRowDef="overstockCheckTableCols"></tr> -->
                    <tr mat-row *matRowDef="let row; columns: overstockCheckTableCols;"></tr>
                </table>
            </mat-expansion-panel>
        </mat-accordion>
    </mat-tab>

    <mat-tab label="Transfers" *ngIf="transfersTabVisible">
        <table mat-table #transferDetailsTable [dataSource]="transferDetails">
            <ng-container matColumnDef="InventoryID">
                <th mat-header-cell *matHeaderCellDef>Item</th>
                <td mat-cell *matCellDef="let value">{{value.InventoryID}}<br />{{value.LotSerialNbr}}</td>
            </ng-container>

            <ng-container matColumnDef="FromLocation">
                <th mat-header-cell *matHeaderCellDef>From</th>
                <td mat-cell *matCellDef="let value">{{value.FromLocationID}}</td>
            </ng-container>

            <ng-container matColumnDef="ToLocation">
                <th mat-header-cell *matHeaderCellDef>To</th>
                <td mat-cell *matCellDef="let value">{{value.ToLocationID}}<br /></td>
            </ng-container>

            <ng-container matColumnDef="Quantity">
                <th mat-header-cell *matHeaderCellDef style="text-align: right;">Qty</th>
                <td mat-cell *matCellDef="let value" class="numeric" [innerHtml]="value.Qty | quantityFraction"></td>
            </ng-container>

            <ng-container matColumnDef="menu">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let piece; let idx = index" class="numeric">
                    <buton mat-button [matMenuTriggerFor]="menuTransfer">
                        <mat-icon>more_vert</mat-icon>
                    </buton>
                    <mat-menu #menuTransfer="matMenu">
                        <button mat-menu-item (click)="queueStockTag(piece.InventoryID, piece.LotSerialNbr, piece.Qty)">
                            <mat-icon>sell</mat-icon>Stock Tag
                        </button>
                        <button mat-menu-item (click)="cancelTransferDetail(idx)">
                            <mat-icon>cancel</mat-icon>Cancel Transfer
                        </button>
                        <!-- <button mat-menu-item (click)="inventoryAdjustment(kvp.value, piece)">
                            <mat-icon>expand</mat-icon>Adjust Qty
                        </button> -->
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="transferTableCols"></tr>
            <tr mat-row *matRowDef="let row; columns: transferTableCols;"></tr>
        </table>
    </mat-tab>

    <mat-tab label="Adjustments" *ngIf="adjustmentsTabVisible">
        <table mat-table #adjustmentDetailsTable [dataSource]="adjustmentDetails">
            <ng-container matColumnDef="InventoryID">
                <th mat-header-cell *matHeaderCellDef>Item</th>
                <td mat-cell *matCellDef="let value">{{value.InventoryID}}<br />{{value.LotSerialNbr ||
                    value.LocationID}}</td>
            </ng-container>

            <ng-container matColumnDef="OriginalQty">
                <th mat-header-cell *matHeaderCellDef style="text-align: right;">Orig</th>
                <td mat-cell *matCellDef="let value" class="numeric"
                    [innerHtml]="value.OriginalQuantity | quantityFraction"></td>
            </ng-container>

            <ng-container matColumnDef="AdjustmentQty">
                <th mat-header-cell *matHeaderCellDef style="text-align: right;">Adjust</th>
                <td mat-cell *matCellDef="let value" class="numeric" [innerHtml]="value.Quantity | quantityFraction">
                </td>
            </ng-container>

            <ng-container matColumnDef="NewQty">
                <th mat-header-cell *matHeaderCellDef style="text-align: right;">New</th>
                <td mat-cell *matCellDef="let value" class="numeric"
                    [innerHtml]="(value.OriginalQuantity || 0) + value.Quantity | quantityFraction"></td>
            </ng-container>

            <ng-container matColumnDef="menu">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let piece; let idx = index" class="numeric">
                    <buton mat-button [matMenuTriggerFor]="menuAdjustment">
                        <mat-icon>more_vert</mat-icon>
                    </buton>
                    <mat-menu #menuAdjustment="matMenu">
                        <button mat-menu-item (click)="editAdjustment(idx)">
                            <mat-icon>edit</mat-icon>Edit Adjustment
                        </button>
                        <button mat-menu-item (click)="cancelAdjustment(idx)">
                            <mat-icon>cancel</mat-icon>Cancel Adjustment
                        </button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="adjustmentTableCols"></tr>
            <tr mat-row *matRowDef="let row; columns: adjustmentTableCols;"></tr>
        </table>
    </mat-tab>

    <mat-tab label="Tags" *ngIf="stockTagQueue.length > 0">
        <table mat-table #stockTagQueueTable [dataSource]="stockTagQueue">
            <ng-container matColumnDef="InventoryID">
                <th mat-header-cell *matHeaderCellDef>Item</th>
                <td mat-cell *matCellDef="let value">{{value.inventoryID}}</td>
            </ng-container>

            <ng-container matColumnDef="LotSerialNbr">
                <th mat-header-cell *matHeaderCellDef>Lot #</th>
                <td mat-cell *matCellDef="let value">{{value.lotSerialNbr}}</td>
            </ng-container>

            <ng-container matColumnDef="Quantity">
                <th mat-header-cell *matHeaderCellDef style="text-align: right;">Qty</th>
                <td mat-cell *matCellDef="let value" class="numeric" [innerHtml]="value.quantity | quantityFraction">
                </td>
            </ng-container>

            <ng-container matColumnDef="menu">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let piece; let idx = index" class="numeric">
                    <buton mat-button [matMenuTriggerFor]="menuTransfer">
                        <mat-icon>more_vert</mat-icon>
                    </buton>
                    <mat-menu #menuTransfer="matMenu">
                        <button mat-menu-item (click)="cancelStockTag(idx)">
                            <mat-icon>cancel</mat-icon>Cancel Tag Print
                        </button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="printTagQueueTableCols"></tr>
            <tr mat-row *matRowDef="let row; columns: printTagQueueTableCols;"></tr>
        </table>
    </mat-tab>
</mat-tab-group>

<ng-template #warehouseSelectionDialog let-data>
    <mat-dialog-content>
        Warehouse: <mayer-warehouse-selector #warehouseSelector></mayer-warehouse-selector>
    </mat-dialog-content>

    <mat-dialog-actions style="justify-content: space-between;">
        <button matSuffix mat-raised-button mat-dialog-close style="justify-content: flex-end;">Cancel</button>
        <button matSuffix mat-raised-button color="primary" [mat-dialog-close]="warehouseSelector.value"
            style="justify-content: flex-end;">OK</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #itemNotInLocationDialog let-data>
    <mat-dialog-content>
        Piece not found in current Location
        <div *ngIf="pieceSearchResults.length == 0"><mat-spinner diameter="20"
                style="display:inline-block;"></mat-spinner>Checking Inventory...</div>
        <div *ngIf="pieceSearchResults.length == 1">
            Piece found in Location: {{pieceSearchResults[0].LocationID}}
        </div>
    </mat-dialog-content>

    <mat-dialog-actions style="justify-content: space-between;">
        <button matSuffix mat-raised-button mat-dialog-close="cancel" style="justify-content: flex-end;">Cancel</button>
        <button matSuffix mat-raised-button *ngIf="pieceSearchResults.length == 1" color="primary"
            [mat-dialog-close]="'transfer-single'" style="justify-content: flex-end;">Transfer to
            {{locationID}}</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #unauditedPiecesDialog let-unauditedPieces>
    <h4 mat-dialog-title>Unaudited Location Contents</h4>
    <mat-dialog-content>
        <table mat-table [dataSource]="unauditedPieces">
            <ng-container matColumnDef="checked">
                <th mat-header-cell *matHeaderCellDef>Lost</th>
                <td mat-cell *matCellDef="let value"><mat-checkbox [(ngModel)]="value.selected"></mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="Item">
                <th mat-header-cell *matHeaderCellDef>Item</th>
                <td mat-cell *matCellDef="let value">{{value.inventoryID}}<br />{{value.lotSerialNbr}}</td>
            </ng-container>

            <ng-container matColumnDef="Qty">
                <th mat-header-cell *matHeaderCellDef style="text-align: right;">Qty</th>
                <td mat-cell *matCellDef="let value" class="numeric"
                    [innerHtml]="value.QtyAvailable | quantityFraction">
                </td>
            </ng-container>

            <!-- <ng-container matColumnDef="menu">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let piece" class="numeric">
                <buton mat-button [matMenuTriggerFor]="menu">
                    <mat-icon>more_vert</mat-icon>
                </buton>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="printStockTag(kvp.value, piece)">
                        <mat-icon>sell</mat-icon>Stock Tag
                    </button>
                    <button mat-menu-item (click)="inventoryAdjustment(kvp.value, piece)">
                        <mat-icon>expand</mat-icon>Adjust Qty
                    </button>
                </mat-menu>
            </td>
        </ng-container> -->

            <tr mat-header-row *matHeaderRowDef="unauditedPieceTableCols"></tr>
            <tr mat-row *matRowDef="let row; columns: unauditedPieceTableCols;"></tr>
        </table>
    </mat-dialog-content>
    <div mat-dialog-actions style="justify-content: space-between;">
        <button mat-raised-button [mat-dialog-close] color="accent" style="justify-content: flex-end;">Cancel</button>
        <span></span>
        <button mat-raised-button [mat-dialog-close]="unauditedPieces" color="primary">Transfer to Lost</button>
    </div>
</ng-template>

<ng-template #inputLegacyTagLotNbr let-data>
    <div><mat-checkbox [(ngModel)]="printLegacyTagReplacements" (click)="inputLegacyLotNbrField.focus()">Print New Stock
            Tag</mat-checkbox></div>

    <table>
        <tr>
            <td style="width:65px;"><item-thumbnail [item]="_1DBarcodeItem" [size]="60"
                    [placeholder]="true"></item-thumbnail>
            </td>
            <td [innerHTML]="_1DBarcodeItem ? (_1DBarcodeItem.InventoryID + '<br />' + _1DBarcodeItem.Description) : 'Loading
                item...'"></td>
        </tr>
    </table>

    <div>
        <fieldset>
            <mat-form-field style=" width:180px;" appearance="fill">
                <mat-label>Serial / Lot #</mat-label>
                <input matInput #inputLegacyLotNbrField scanInput="*" (scanned)="onLegacyInputLotNbr($event)" />
            </mat-form-field>
        </fieldset>
    </div>

    <div mat-dialog-actions style="justify-content: space-between;">
        <button mat-raised-button [mat-dialog-close] color="accent" style="justify-content: flex-end;">Cancel</button>
    </div>
</ng-template>

<ng-template #adjustPieceQtyDialog let-data>
    <h4 mat-dialog-title>Item Adjustment</h4>
    <mat-dialog-content>

        <div class="system-info" style="white-space:nowrap; padding-bottom:5px;">
            <table>
                <tr>
                    <td>
                        <span><label>Qty Available:</label>&nbsp;{{data.piece.QtyAvailable}}
                            {{data.stockItem.BaseUOM}}</span>
                    </td>
                </tr>

                <tr>
                    <td>
                        <span style="width: 95%; font-size:0.9em; line-height:1.1; text-align:center; color: red;"
                            [style.display]="data.adjustment.AdjustmentAcceptable ? 'none' : 'inline-block'">
                            Adjustment quantity exceeds<br />acceptable range</span>
                    </td>
                </tr>

                <tr>
                    <td>
                        <mat-form-field appearance="fill" style="width:9em;">
                            <mat-label>Adjust To</mat-label>
                            <input #adjustRemainingOnHandInput [(ngModel)]="data.adjustment.AdjustQtyTo"
                                inputmode='quantity' autofocus matInput
                                (keyup.enter)="adjustPieceQtyDialogRefOnEnter(data.adjustment)" />
                            <button mat-icon-button matSuffix (click)="data.adjustment.AdjustQtyTo = null"
                                *ngIf="data.adjustment.AdjustQtyTo !== null">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-form-field>
                    </td>
                </tr>

                <tr>
                    <td>
                        <span *ngIf="data.adjustment.AdjustQtyTo !== null" style="margin-left:1em;">Adjustment:
                            {{data.adjustment.AdjustQtyTo - data.piece.QtyAvailable
                            | signed}}
                            {{data.stockItem.BaseUOM}}</span>
                    </td>
                </tr>
            </table>
        </div>
    </mat-dialog-content>
    <div mat-dialog-actions style="justify-content: space-between;">
        <button mat-raised-button [mat-dialog-close]="false" color="accent"
            style="justify-content: flex-end;">Cancel</button>
        <span></span>
        <button mat-raised-button [mat-dialog-close]="true" [disabled]="!data.adjustment.AdjustmentAcceptable"
            color="primary">OK</button>
    </div>
</ng-template>

<ng-template #adjustInNewPieceDialog let-data>
    <h4 mat-dialog-title>That piece does not exist in Acumatica.<br />Create It?</h4>
    <mat-dialog-content>

        <div class="system-info" style="white-space:nowrap; padding-bottom:5px;">
            <table>
                <tr>
                    <td>
                        <span><label>Inventory ID:</label>&nbsp;{{data.adjustment.InventoryID}}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span><label>Lot/Serial #:</label>&nbsp;{{data.adjustment.LotSerialNbr}}</span>
                    </td>
                </tr>

                <tr>
                    <td>
                        <mat-form-field appearance="fill" style="width:9em;">
                            <mat-label>Qty On Hand</mat-label>
                            <input #adjustRemainingOnHandInput [(ngModel)]="data.adjustment.Quantity"
                                (keyup.enter)="adjustInNewPieceOKButton._elementRef.nativeElement.click()"
                                inputmode='quantity' autofocus matInput />
                            <button mat-icon-button matSuffix (click)="data.adjustment.Quantity = null"
                                *ngIf="data.adjustment.Quantity !== null">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-form-field>
                    </td>
                </tr>
            </table>
        </div>
    </mat-dialog-content>
    <div mat-dialog-actions style="justify-content: space-between;">
        <button mat-raised-button [mat-dialog-close]="false" color="accent"
            style="justify-content: flex-end;">Cancel</button>
        <span></span>
        <button #adjustInNewPieceOKButton mat-raised-button [mat-dialog-close]="true"
            [disabled]="!data.adjustment.AdjustmentAcceptable" color="primary">OK</button>
    </div>
</ng-template>